import { Button, Divider, Grid, IconButton, useMediaQuery } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import globalStyles from "../../../assets/styles/global.module.scss";
import styles from "../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss";
import templateStyles from '../../../assets/styles/componentStyles/template.module.scss'
import GlobalPageHeaderText from '../../utility/globalPageHeaderText';
import { whiteColor } from '../../../utils/colors';
import IconsColor from '../../utility/iconsColor';
import AddIcon from '@mui/icons-material/Add';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import OrganizationHeaderText from './organizationHeaderText';
import { Outlet, useSearchParams } from 'react-router-dom';
import { hasOrganizationManageAccess, hasTicketSubstatusManageAccess } from '../../../utils/constants';
import { userAssignmentRolesToHaveAccessToAddMembers, userRolesToHaveAccessToAddMembers } from './organizationConstants';
import { dashboardBreadcrumb, workspaceBreadcrumb } from '../../../utils/breadcrumb';
import { useTicketStore } from '../../../store/ticketStore';
import { useShallow } from 'zustand/react/shallow';

const Organization = () => {

    const [searchParams, setSearchParams] = useSearchParams()
    const organization_id = searchParams.get('organization_id')

    const pathname = window.location.pathname?.toLowerCase();
    const breakPoints = {
        smallScreen: useMediaQuery('(max-width : 600px) and (min-width : 0px)'),
    }

    const { userDetail, organizationDetails, apiRoutesPermissionAssignment, setFlagAddMemberPopup } = useContext(UserContext) as UserContextPayload;
    const { setFlagCreateSubStatusPopup, setSelectedSubStatus } = useTicketStore(
        useShallow((state) => ({
            setFlagCreateSubStatusPopup: state.setFlagCreateSubStatusPopup,
            setSelectedSubStatus: state.setSelectedSubStatus,
        }))
    )

    const getMainHeadText = () => {
        if (organizationDetails && organizationDetails.length > 1 && !organization_id) {
            return "Workspace";
        } else {
            return <OrganizationHeaderText />
        }
    }

    const hasAccessToAddNewMember = () => {
        if(!hasOrganizationManageAccess(apiRoutesPermissionAssignment, userDetail)){
            return false;
        }
        if(organizationDetails && (organization_id || organizationDetails.length == 1)){
            if(!userDetail?.user_assignment_role_data?.length){ // In the case of No User Assignment Role.
                return userDetail && userDetail.user_organization_data && userRolesToHaveAccessToAddMembers?.includes(userDetail.user_organization_data.user_organization_role_name?.toLowerCase());
            } else { // In the case of User Assignment Role.
                return userAssignmentRolesToHaveAccessToAddMembers?.includes(userDetail?.user_assignment_role_data?.[0]?.chronox_user_role_name?.toLowerCase());
            }
            }
        return false;
    }

    const renderActionBlock = () => {
        switch(pathname){
            case '/organization':
                if(hasAccessToAddNewMember()){
                    return (
                        <Grid item>
                            <Grid container className={globalStyles.alignItemCenter}>
                                <Grid item className={`${templateStyles.addChatbotBtn}`}>
                                    <Button
                                        variant='outlined'
                                        size='large'
                                        fullWidth
                                        startIcon={<IconsColor iconName="plus" fillColor={whiteColor} width="15px" height="15px" />}
                                        className={`${globalStyles.addDocumentBtn} ${styles.addNewMemberBtn}`}
                                        onClick={() => setFlagAddMemberPopup(true)}
                                    >
                                        New Member
                                    </Button>
                                </Grid>
                                <IconButton
                                    className={`${globalStyles.cmpGlobalMobileAddIcon} ${templateStyles.addChatbotIcon}`}
                                    onClick={() => setFlagAddMemberPopup(true)}
                                >
                                    <AddIcon className={styles.addNewMemberBtnIcon} />
                                </IconButton>
                            </Grid>
                        </Grid>
                    );
                } else return <></>;
            case '/organization/ticketsubstatus':
                if(hasTicketSubstatusManageAccess(userDetail)){
                    return (
                        <Grid item>
                            <Grid container className={globalStyles.alignItemCenter}>
                                <Grid item className={`${templateStyles.addChatbotBtn}`}>
                                    <Button
                                        variant='outlined'
                                        size='large'
                                        fullWidth
                                        startIcon={<IconsColor iconName="plus" fillColor={whiteColor} width="15px" height="15px" />}
                                        className={`${globalStyles.addDocumentBtn} ${styles.addNewMemberBtn}`}
                                        onClick={() => { setFlagCreateSubStatusPopup(true); setSelectedSubStatus(null)}}
                                    >
                                        New Substatus
                                    </Button>
                                </Grid>
                                <IconButton
                                    className={`${globalStyles.cmpGlobalMobileAddIcon} ${templateStyles.addChatbotIcon}`}
                                    onClick={() => { setFlagCreateSubStatusPopup(true); setSelectedSubStatus(null)}}
                                >
                                    <AddIcon className={styles.addNewMemberBtnIcon} />
                                </IconButton>
                            </Grid>
                        </Grid>
                    )
                } else return <></>;
            default: 
                return <></>;
        }
    }
    
    return (
        <>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${globalStyles.fullwidth} ${styles.templateWrapper}`}>
                <Grid container className={styles.viewOrganizationGridPadding}>
                    <Grid item xs={12} sm={12}>
                        <Grid container className={globalStyles.alignItemCenter} direction={"column"}>
                            <Grid item className={`${globalStyles.fullwidth} ${styles.viewOrganizationHeaderGrid}`}>
                                <GlobalPageHeaderText
                                    mainHeadText={getMainHeadText()}
                                    flagMainTextOnly
                                    actionBlock={renderActionBlock()}
                                />
                                {!breakPoints.smallScreen && <Divider className={`${globalStyles.fullwidth} ${globalStyles.dividerStyles} ${styles.dividerStyle} ${styles.organizationHeaderDivider}`} />}
                            </Grid>
                        </Grid>

                        <Outlet />
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default Organization
